import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { StatisticProvider } from '@internal-providers/statistic.provider';
import { IStatisticParams } from '@shared-libs/interfaces';

@Component({
	selector: 'impact-count-statistic-component',
	templateUrl: 'impact-count-statistic.component.html',
	styleUrls: ['./impact-count-statistic.component.scss'],
})
export class ImpactCountStatisticComponent implements OnInit {
	@Input() public params: IStatisticParams;
	@Input() public paramsChanged: EventEmitter<IStatisticParams>;
	public counts: { total: number; loans: number; essentialServices: number; educations: number };
	public selectedPeriod: { startDate: string; endDate: string };

	public readonly periods = [
		{ startDate: '2022-01-01', endDate: '2024-12-31' },
		{ startDate: '2025-01-01', endDate: '2100-12-31' },
	];

	constructor(private readonly provider: StatisticProvider) {}

	public async ngOnInit(): Promise<void> {
		this.onPeriodFilter(this.periods[1], false);
		this.counts = await this.provider.getImpactCountStatistic(this.params);
		this.paramsChanged.subscribe(async (params: IStatisticParams) => {
			this.counts = await this.provider.getImpactCountStatistic(params);
		});
	}

	public onPeriodFilter(period: { startDate: string; endDate: string }, emitParams: boolean = true): void {
		this.selectedPeriod = period;
		this.params = { ...this.params, dateRange: period };
		if (emitParams) {
			this.paramsChanged.emit(this.params);
		}
	}
}
